export default __webpack_public_path__ + "08864951d39b1eeb86e889dcb7968bc6.png";